module.exports = __webpack_public_path__ + "media/domenj/JuritecaBeta-9e8223f0.jpg";